import React, { useMemo, useRef } from 'react';
import { Container, Sprite } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { isMobile } from '../../../../core/helpers/isMobile';

import { freeBetStore } from '../../../../store/freeBetStore';

import TextOrderingByWidth from '../../textOrderingByWidth';
import { isoStandard } from '../../../../core/helpers/isoStandard';
import { applicationStore } from '../../../../store/applicationStore';

const TotalWinAmountComponent = observer(
  ({
    y = 0,
    children,
    isVisible,
    amountValue,
    currencySymbol,
    backGroundTexture,
    isVisibleTotalAmount,
    canvasTranslationKeys,
  }) => {
    const { isShowLicenseMode, isDemo } = applicationStore;
    const freeBetTotalWinRef = useRef(null);
    const { currentFreeBet } = freeBetStore;

    const texts = useMemo(() => {
      return [
        {
          id: 0,
          text: canvasTranslationKeys.TOTAL_WIN,
          style: { fill: '#FFC33E', _fontWeight: 700, _fontSize: isMobile() ? 20 : 20 },
          ref: null,
        },
        {
          id: 1,
          text: isoStandard(amountValue, true),
          style: { fill: '#FFFFFF', _fontWeight: 700, _fontSize: isMobile() ? 24 : 26 },
          ref: freeBetTotalWinRef,
        },
        {
          id: 2,
          text: currencySymbol,
          style: { fill: '#FFFFFF', _fontWeight: 700, _fontSize: isMobile() ? 20 : 26 },
          ref: null,
        },
      ];
    }, [amountValue, currencySymbol, canvasTranslationKeys]);

    const updateTextByLicense = useMemo(() => {
      return isShowLicenseMode && !isDemo ? [texts[0], texts[2], texts[1]] : texts;
    }, [isShowLicenseMode, isDemo, texts]);

    const freeBetLeftCountTexts = useMemo(() => {
      return [
        {
          id: 0,
          text: canvasTranslationKeys.FREE_SPINS_BONUS_2,
          style: { fill: '#FFC33E', _fontWeight: 700, _fontSize: isMobile() ? 16 : 16 },
          ref: null,
        },
        {
          id: 1,
          text: `${currentFreeBet?.remainingCount || '0'}`,
          style: { fill: '#FFFFFF', _fontWeight: 700, _fontSize: isMobile() ? 20 : 20 },
          ref: freeBetTotalWinRef,
        },
      ];
    }, [canvasTranslationKeys.FREE_SPINS_BONUS_2, currentFreeBet]);

    return (
      <Container y={y} name='TotalWinAmountComponent' visible={isVisible}>
        <Sprite anchor={0.5} scale={isMobile() ? 0.77 : 0.5} texture={backGroundTexture} />
        {isVisibleTotalAmount && <TextOrderingByWidth texts={updateTextByLicense} y={-15} />}
        {children}
        <TextOrderingByWidth texts={freeBetLeftCountTexts} y={15} />
      </Container>
    );
  }
);

export default TotalWinAmountComponent;
